angular.module('leanlaw').factory('reportDefinitions', ['userService', 'templateDefinition', 'clientUserTagDefinition', 'collectionDetailDefinition', 'wipBilledCollectedDefinition', 'billableDetailDefinition', 'depositListsDefinition', 'originationDefinition', 'originationDetailDefinitionByUser', 'originationDetailDefinitionByMatter', 'originationDetailPaymentsDefinition', 'originationInfoDefination', function (userService, templateDefinition, clientUserTagDefinition, collectionDetailDefinition, wipBilledCollectedDefinition, billableDetailDefinition, depositListsDefinition, originationDefinition, originationDetailDefinitionByUser, originationDetailDefinitionByMatter, originationDetailPaymentsDefinition, originationInfoDefination) {
  let _me = {};
  userService.me().then(me => {
    _me = me;
  });
  const responsibleConfig = params => ({
    query: {
      accountFilter: 'primary',
      reportType: 'billable'
    },
    show: params.show
  });
  const responsibleDetailConfig = params => ({
    query: {
      scope: 'primary',
      scopeAccount: params.userId,
      reportType: 'billable'
    },
    show: params.show
  });
  const definitions = {
    template: {
      label: 'Report Template',
      definition: templateDefinition
    },
    'wip-detail': {
      label: 'WIP Detail',
      definition: billableDetailDefinition
    },
    'my-wip-detail': {
      label: 'My WIP Detail',
      definition: billableDetailDefinition,
      params: {
        onlyMyWipDetail: true
      },
      select: row => {
        userService.me().then(me => {
          _me = me;
        });
        // Use new modal route if feature flag is enabled
        const useNewModal = (_me.features?.timeEntriesTab ?? false) && (_me.settings?.enableNewTimeEntry ?? false);
        const entryRoute = useNewModal ? 'reports.generic.entry2' : 'reports.generic.entry';
        return {
          route: row.item.type === 'Fixed Fee' ? `reports.generic.charges` : row.item.type === 'Time' ? 'reports.generic.entry' : `reports.generic.expenses`,
          params: {
            chargeId: row.item.id,
            expenseId: row.item.id,
            entryId: row.item.id,
            type: row.item.type
          }
        };
      }
    },
    'origination': {
      label: 'Collected by Originating',
      definition: originationDefinition,
      select: user => ({
        report: 'origination-detail-matter',
        params: {
          userId: user.id,
          returnLabel: user.label
        }
      })
    },
    'origination-detail-matter': {
      label: 'Origination Detail',
      definition: originationDetailDefinitionByMatter
      // select: (row, _, params) => ({
      //   report: 'origination-detail-payments',
      //   params: {
      //     userId: params.userId,
      //     clientId: row.clientId,
      //     matterId: row.matterId,
      //     returnLabel: row.name,
      //   },
      // })
    },
    'origination-detail-user': {
      label: 'Origination Detail',
      definition: originationDetailDefinitionByUser
      // select: (row, _, params) => ({
      //   report: 'origination-detail-payments',
      //   params: {
      //     userId: params.userId,
      //     clientId: row.clientId,
      //     matterId: row.matterId,
      //     returnLabel: row.name,
      //   },
      // })
    },
    'origination-detail-payments': {
      label: 'Collection Detail',
      definition: originationDetailPaymentsDefinition
    },
    'my-origination-info': {
      label: 'My Origination Info',
      definition: originationInfoDefination
    },
    'responsible-billable': {
      label: 'Billable by Responsible',
      definition: clientUserTagDefinition(responsibleConfig),
      params: {
        type: 'user',
        include: 'billableDetail',
        show: {
          billed: true,
          matterForUser: false
        }
      },
      select: user => ({
        // Use 'report' to link to another generic report
        report: 'responsible-billable-detail',
        params: {
          userId: user.id,
          returnLabel: user.label
        }
      })
    },
    'responsible-billable-detail': {
      label: 'Billable by Client',
      definition: clientUserTagDefinition(responsibleDetailConfig),
      params: {
        type: 'client',
        include: 'billableDetail',
        show: {
          billed: true,
          matterForUser: false
        }
      },
      select: (client, matter) => ({
        // Use 'route' to link to any angular route (e.g. non-generic reports)
        route: 'reports.client-summary',
        params: {
          clientId: client && client.id,
          matterId: matter && matter.id
        }
      })
    },
    'user-wip-billed-collected': {
      label: 'WIP, Billed, Collected by User',
      definition: wipBilledCollectedDefinition(params => ({
        query: {
          reportType: "wip-billed-collected"
        }
      })),
      params: {
        type: 'user',
        showUnassigned: true
      },
      select: user => ({
        // Use 'report' to link to another generic report
        report: 'user-wip-billed-collected-detail',
        params: {
          userId: user.id,
          returnLabel: user.label
        }
      })
    },
    'user-wip-billed-collected-detail': {
      label: 'WIP, Billed, Collected by Client',
      definition: wipBilledCollectedDefinition(params => ({
        query: {
          account: params.userId,
          reportType: "wip-billed-collected"
        }
      })),
      params: {
        type: 'client'
      }
      // select: (client, matter) => ({
      //   // Use 'route' to link to any angular route (e.g. non-generic reports)
      //   route: 'reports.client-summary',
      //   params: {
      //     clientId: client && client.id,
      //     matterId: matter && matter.id,
      //   },
      // }),
    },
    'my-wip-billed-collected': {
      label: 'My WIP, Billed, Collected',
      definition: wipBilledCollectedDefinition(params => ({
        query: {
          account: _me.id,
          reportType: "wip-billed-collected"
        }
      })),
      params: {
        type: 'client'
      }
    },
    'responsible-wip-billed-collected': {
      label: 'WIP, Billed, Collected by Responsible',
      definition: wipBilledCollectedDefinition(params => ({
        query: {
          accountFilter: 'primary',
          reportType: 'wip-billed-collected'
        },
        show: params.show
      })),
      params: {
        type: 'user',
        show: {
          matterForUser: false,
          archivedStatus: true
        }
      },
      select: user => ({
        // Use 'report' to link to another generic report
        report: 'responsible-wip-billed-collected-detail',
        params: {
          userId: user.id,
          returnLabel: user.label
        }
      })
    },
    'responsible-wip-billed-collected-detail': {
      label: 'WIP, Billed, Collected by Client',
      definition: wipBilledCollectedDefinition(params => ({
        query: {
          scope: 'primary',
          scopeAccount: params.userId,
          reportType: 'wip-billed-collected'
        },
        show: params.show
      })),
      params: {
        type: 'client',
        show: {
          matterForUser: false
        }
      }
      // select: (client, matter) => ({
      //   // Use 'route' to link to any angular route (e.g. non-generic reports)
      //   route: 'reports.client-summary',
      //   params: {
      //     clientId: client && client.id,
      //     matterId: matter && matter.id,
      //   },
      // }),
    },
    'client-wip-billed-collected': {
      label: 'WIP, Billed, Collected by Client',
      definition: wipBilledCollectedDefinition(params => ({
        query: {
          reportType: "wip-billed-collected"
        }
      })),
      params: {
        type: 'client'
      },
      select: (client, matter) => ({
        // Use 'report' to link to another generic report
        report: 'client-wip-billed-collected-detail',
        params: {
          clientId: client && client.id,
          matterId: matter && matter.id,
          returnLabel: matter ? matter.label : client.label
        }
      })
    },
    'client-wip-billed-collected-detail': {
      label: 'WIP, Billed, Collected by User',
      definition: wipBilledCollectedDefinition(params => ({
        query: {
          clientId: params.clientId,
          reportType: "wip-billed-collected"
        }
      })),
      params: {
        type: 'user',
        showUnassigned: true
      }
      // select: (client, matter) => ({
      //   // Use 'route' to link to any angular route (e.g. non-generic reports)
      //   route: 'reports.client-summary',
      //   params: {
      //     clientId: client && client.id,
      //     matterId: matter && matter.id,
      //   },
      // }),
    },
    'practice-area-wip-billed-collected': {
      label: 'WIP, Billed, Collected by Practice Area',
      definition: wipBilledCollectedDefinition(params => ({
        query: {
          reportType: "wip-billed-collected"
        }
      })),
      params: {
        type: 'matterTag'
      },
      select: matterTag => ({
        // Use 'report' to link to another generic report
        report: 'practice-area-wip-billed-collected-detail',
        params: {
          matterTagId: matterTag.id || "none",
          returnLabel: matterTag.label
        }
      })
    },
    'practice-area-wip-billed-collected-detail': {
      label: 'WIP, Billed, Collected by Client',
      definition: wipBilledCollectedDefinition(params => ({
        query: {
          matterTag: params.matterTagId,
          reportType: "wip-billed-collected"
        }
      })),
      params: {
        type: 'client'
      }
      // select: (client, matter) => ({
      //   // Use 'route' to link to any angular route (e.g. non-generic reports)
      //   route: 'reports.client-summary',
      //   params: {
      //     clientId: client && client.id,
      //     matterId: matter && matter.id,
      //   },
      // }),
    },
    'responsible-collected': {
      label: 'Collected by Responsible',
      definition: clientUserTagDefinition(params => ({
        query: {
          accountFilter: 'primary',
          reportType: 'wip-billed-collected'
        },
        show: params.show
      })),
      params: {
        type: 'user',
        include: 'collectedDetail',
        show: {
          billed: false,
          matterForUser: false,
          archivedStatus: true
        }
      },
      select: user => ({
        report: 'responsible-collected-detail',
        params: {
          userId: user.id,
          returnLabel: user.label,
          show: {
            matterForUser: false,
            archivedStatus: true
          }
        }
      })
    },
    'responsible-collected-detail': {
      label: 'Collected by Client',
      definition: clientUserTagDefinition(params => ({
        query: {
          scope: 'primary',
          scopeAccount: params.userId,
          reportType: 'wip-billed-collected'
        },
        show: params.show
      })),
      params: {
        type: 'client',
        include: 'collectedDetail',
        show: {
          matterForUser: false,
          archivedStatus: true
        }
      },
      select: (client, matter) => ({
        report: 'responsible-collected-invoices',
        params: {
          clientId: client && client.id,
          matterId: matter && matter.id
        }
      })
    },
    'responsible-collected-invoices': {
      label: 'Collection Detail',
      definition: collectionDetailDefinition(params => ({
        scope: 'primary',
        scopeAccount: params.userId,
        reportType: 'wip-billed-collected'
      })),
      params: {}
    },
    'deposit-lists': {
      label: 'Deposit Report',
      definition: depositListsDefinition,
      params: {}
    }
  };
  return definitions;
}]);